/*
 * @@Description: group-table
 * @@Author: MuYang
 * @Date: 2021-07-28 10:57:30
 * @LastEditTime: 2021-10-22 16:56:03
 */
import T from './component/index'
import { TableProps } from './util/default-props'
import { PREFIX } from './config'
import openEvent from './mixin/openEvent'
const SLOTNAME = 'groupTitle'
const ErrorSLOTNAME  = 'groupError'

export default {
  name: 'GTable',
  components: {
    T
  },
  props: TableProps,
  mixins: [openEvent],
  methods: {
    normalizeSlotRender (slots, scopedSlots, slotsRenderMap) {
      const slotNames = [SLOTNAME, ErrorSLOTNAME]
      let slotMap = {}
      slotNames.forEach(slotName => {
        let renderChild
        if (slots[slotName]) {
          renderChild = slots[slotName]
        } else if (scopedSlots[slotName]) {
          renderChild = scopedSlots[slotName]
        } else if (slotsRenderMap[slotName]) {
          renderChild = slotsRenderMap[slotName]
        }
        if (renderChild) {
          slotMap[`${slotName}Render`] = (payload) => {
            const customRender = payload.selectColumn?.customRender
            const domSlot = typeof renderChild === 'function' ? renderChild(this.$createElement, payload) : renderChild
            return domSlot ? <div class={`${PREFIX}-group-${slotName}`}>
              <div class={`${PREFIX}-group-position`}>
                {customRender && customRender({row: payload.record, $index: payload.groupIndex})}
                {domSlot}
              </div>
            </div> : null
          }
        }
      })
      return slotMap
    }
  },
  render (h) {
    // 初始化
    const { $scopedSlots, $slots, $props, dataSource } = this
    const slotsRenderMap = this.normalizeSlotRender($scopedSlots, $slots, $props.slotsRenderMap)
    const tProps = {
      props: {
        ...$props,
        dataSource,
        slotsRenderMap,
        groupScroll: true,
        isGroup: true
      },
      class: `${PREFIX}-group`,
      scopedSlots: $scopedSlots
    }
    return <T {...tProps}>{$slots}</T>
  }
}
